import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import { Button, Card } from 'react-bootstrap';
import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import { Form } from 'react-final-form';
import { UserEmail } from './UserEmail';
import FinalFormField from 'common/components/final-form/FinalFormField';

interface IEmailVerifyPresenter {
  error: string | null;
  onSubmit: (values: UserEmail) => void;
  submitting: boolean;
}
function EmailVerifyPresenter(props: IEmailVerifyPresenter) {
  return (
    <Page template={PageTemplates.centered}>
      <Card>
        <Card.Body>
          {props.error && (
            <Alert type={AlertType.danger}>
              {props.error === 'Failed to fetch'
                ? 'Please enter an email address'
                : props.error}
            </Alert>
          )}

          <Form<UserEmail> onSubmit={props.onSubmit}>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <FinalFormField
                  name='email'
                  label='Email Address'
                  type='email'
                />
                <Button
                  type='submit'
                  variant='primary'
                  disabled={props.submitting}
                >
                  Submit
                </Button>
              </form>
            )}
          </Form>
        </Card.Body>
      </Card>
    </Page>
  );
}

export default EmailVerifyPresenter;
